import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ListHeaderContainer,
  PaginationContainer,
  TableContainer,
} from "../../../../containers";
import { filterObjectKeys } from "../../../../helpers";
import { getListCollaborators } from "../../../../store/collaborators/thunks";
import { LoadingComponent } from "../../../../components";
const URL = "configuracion/landing/colaboradores";
const dataInput = { id: "searchCollaborators", placeholder: "Buscar variable" };
const allowedKeys = ["id", "name", "order", "active"];
const dataHeader = {
  title: "Colaboradores",
  nameButton: "Crear Colaborador",
  url: "/configuracion/landing/colaboradores/crear",
};

export const SettingLandingCollaboratorsIndexPage = () => {
  const { collaboratorsData, showLoading } = useSelector(
    (state) => state.listCollaborators
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();
  const serachParams = new URLSearchParams(search);
  const pageCollaborators = serachParams.get("page");
  const searchCollaborators = serachParams.get("search");

  let collaboratorsParams = {
    page_size: 20,
    page: pageCollaborators ?? 1,
    search: searchCollaborators ?? "",
  };

  useEffect(() => {
    dispatch(getListCollaborators(collaboratorsParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageCollaborators, searchCollaborators]);

  const filter = () => {
    const searchValue = document.getElementById("searchCollaborators").value;
    if (searchValue === "") {
      dispatch(getListCollaborators());
      navigate("/" + URL);
      return;
    }
    const searchUrl = `/configuracion/landing/colaboradores?search=${searchValue}`;
    navigate(searchUrl);
  };

  const handleKeyDown = (e) => {
    const searchValue = document.getElementById("searchCollaborators").value;
    if (e.key === "Backspace" && searchValue.length === 1) {
      dispatch(getListCollaborators());
      navigate("/" + URL);
    }
    if (e.key !== "Enter") return;
    filter();
  };

  const getUrl = (id) => {
    return `/configuracion/landing/colaboradores/${id}/detalles`;
  };

  const newData = collaboratorsData?.results?.map((obj) =>
    filterObjectKeys(obj, allowedKeys)
  );

  return (
    <section className="clientIndexPage">
      <ListHeaderContainer data={dataHeader} />
      {!showLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <TableContainer
            filter={filter}
            handleKeyDown={handleKeyDown}
            dataInput={dataInput}
            data={newData}
            url={getUrl}
            titles={allowedKeys}
            isFilter={false}
          />
          <PaginationContainer data={collaboratorsData} />
        </>
      )}
    </section>
  );
};
